import Box from '@mui/material/Box';
import Popper from '@mui/material/Popper';
import Fade from '@mui/material/Fade';
import Paper from '@mui/material/Paper';
import { ClickAwayListener } from '@mui/base/ClickAwayListener';
import { useState } from 'react';
import './FloatingQuestion.css';

const FloatingQuestion = ({ id, prefix, description, ...rest }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [open, setOpen] = useState(false);
  const [placement, setPlacement] = useState();

  const handleClose = (evt) => {
    setOpen(false);
  };

  const handleOpen = (newPlacement) => (event) => {
    event.preventDefault();
    setAnchorEl(event?.currentTarget);
    setOpen(true);
    setPlacement(newPlacement);
  };

  return (
    <ClickAwayListener onClickAway={handleClose}>
      <Box
        className='floating-question'
        id={id}
        {...rest}
        onMouseOver={handleOpen('bottom')}
        onMouseLeave={handleClose}
        style={{
          position: 'relative'
        }}
      >
        <div style={{ display: 'flex', gap: '9px', alignItems: 'center' }}>
          <span className={`floating-question__prefix  ${open ? 'floating-question__prefix--active' : ''} `}>
            {prefix}
          </span>
        </div>
        <Box sx={{ position: 'relative' }}>
          <Popper className='marking-menu' open={open} anchorEl={anchorEl} placement={placement} transition>
            {({ TransitionProps }) => (
              <Fade {...TransitionProps} timeout={350}>
                <Paper>
                  <div className='floating-question_content'>
                    <span className='floating-question__text'>{description}</span>
                  </div>
                </Paper>
              </Fade>
            )}
          </Popper>
        </Box>
      </Box>
    </ClickAwayListener>
  );
};

export default FloatingQuestion;
